import * as React from "react";

import cs from "classnames";
import styles from "./index.module.scss";

interface IProps {
	primary?: boolean;
	children?: React.ReactNode;
	title?: string;
	gray?: boolean;
	boxRadius?: boolean;
	prefix?: "ریال" | string;
}
const Box: React.FC<IProps> = (props: IProps) => {
	return (
		<div
			className={cs(styles.box, {
				[styles["box--primary"]]: props.primary,
				[styles["box--gray"]]: props.gray,
				[styles["box--boxRadius"]]: props.boxRadius,
			})}
		>
			<h3>{props.title}</h3>
			{props.children}
			{props.prefix ? ` ${props.prefix}` : null}
		</div>
	);
};

export default Box;
